<template>
  <div id="topNotice">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-xs-10">
          <img src="~@/assets/svg/ic-notice.svg" class="icon-notice" alt="icon-notice">
          <router-link class="title"
                       :to="{name: 'notice', params: { id: notice.id }}"
                       @click.native="$emit('close')"
          >
            {{ notice.title }}
          </router-link>
        </div>
        <div class="col-sm-4 col-xs-2 text-right">
          <label class="week-close hidden-xs" @click="hideNoticeForWeek">7일간 보지 않기</label>
          <a href="#" class="notice-close" @click.prevent="$emit('close')">
            <img src="~@/assets/svg/ic-close.svg" class="icon-close" alt="icon-close">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'top-notice',
    props: {
      notice: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {
        isActive: true
      }
    },
    methods: {
      hideNoticeForWeek () {
        localStorage.setItem('hide_notice', JSON.stringify({
          id: this.notice.id,
          expiration_date: moment().add(7, 'd')
        }))

        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  #topNotice {
    position: fixed;
    top: 0;
    width: 100%;
    height: 64px;
    padding: 22px 8px 0;
    background-color: #4071ff;
    z-index: 99;

    .title {
      display: inline-block;
      max-width: calc(100% - 28px);
      margin: 0 0 0 4px;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.8px;
      color: $hzc-white;
      float: left;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .week-close {
      margin: 0 80px 0 0;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: -0.35px;
      text-decoration: underline;
      color: $hzc-white;
      cursor: pointer;
    }

    .notice-close {
      display: inline-block;
      height: 20px;
      padding: 1px 0 0;
      cursor: pointer;
      float: right;
    }

    .icon-notice {
      float: left;
    }

    .icon-close {
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TopNotice.vue